import type { DashboardFeatureConfig } from '../../types/features/DashboardFeatureConfig';

export const dashboard: DashboardFeatureConfig = {
    showContractNumber: true,
    showCurrentInstallment: false,
    showRemainingTerm: false,
    showAmountToPay: true,
};
